
import { mapState, mapMutations, mapActions, mapGetters } from "vuex"

export default {
  name: "Default",
  data: () => ({
    imageUrl: process.env.IMAGE_URL,
    accountPages: [
      {
        name: "Premium",
        url: "/account/premium",
        show: false,
        id: "premium",
      },
      {
        name: "Orders",
        url: "/account/orders",
        show: true,
        id: "orders",
      },
      {
        name: "Details",
        url: "/account/details",
        show: true,
        id: "details",
      },
    ],
  }),
  computed: {
    ...mapGetters(["cartItemCount"]),
    ...mapState([
      "chosenMaker",
      "authenticated",
      "chosenDiscount",
      "templateLoading",
      "rewards",
      "makerCategories",
      "cart",
      "makers",
      "cuisines",
      "chosenProduct",
      "showCart",
      "user",
      "reviews",
      "showAccount",
    ]),
  },
  watch: {
    authenticated(to) {
      to && this.getCustomer()
    },
    $route(from, to) {
      if (to.fullPath.includes("account") && !this.authenticated) {
        this.$router.push("/login")
      }
      if (to.name !== from.name) {
        if (to.name !== "search" || to.name !== "index") {
          this.deepFilter(false)
        }
        this.setCartStatus(false)
        this.setSearchStatus(false)
        this.setShowAccount(false)
      }
    },
    showCart(to) {
      if (to) {
        document.querySelector("html").style.overflowY = "hidden"
      } else {
        document.querySelector("html").style.overflowY = "scroll"
      }
    },
    user(to) {
      if (
        (to?.organisation?.subscription && to.role === "owner") ||
        (to?.organisation?.subscription?.has_group_ordering &&
          to.role !== "owner")
      ) {
        this.accountPages.find((item) => item.id === "premium").show = true
      }
    },
  },
  async mounted() {
    this.setWindowSize(window.innerWidth)
    window.addEventListener("resize", this.handleResize)
    await this.init()
    this.$route.query.discount &&
      this.setChosenDiscount({
        discount_code: this.$route.query.discount
          .toUpperCase()
          .replace(/\s+/g, ""),
      })
    this.setTemplateLoading(false)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
  },
  methods: {
    ...mapMutations({
      setCustomer: "SET_CUSTOMER",
      setDeliveryAddress: "SET_DELIVERY_ADDRESS",
      setAuthenticated: "SET_AUTHENTICATED",
      setCart: "SET_CART",
      setOrder: "SET_ORDER",
      setChosenDiscount: "SET_CHOSEN_DISCOUNT",
      setWindowSize: "SET_WINDOW_SIZE",
      setSearchStatus: "SET_SEARCH_STATUS",
      setCartStatus: "SET_CART_STATUS",
      setDealId: "SET_DEAL_ID",
      setShowAccount: "SET_SHOW_ACCOUNT",
      setTemplateLoading: "SET_TEMPLATE_LOADING",
    }),
    ...mapActions([
      "getMakerBySlug",
      "addToCart",
      "getShareCart",
      "deepFilter",
      "getCustomer",
      "customerLogout",
      "organisation",
    ]),

    init() {
      if (this.$route.query.loginAs) {
        this.setAuthenticated(JSON.parse(this.$route.query.loginAs))
        this.$router.push("/search")
      } else {
        this.setAuthenticated(
          JSON.parse(localStorage.getItem("authenticated") || false)
        )
        this.setCustomer(JSON.parse(localStorage.getItem("customer") || false))
      }
      this.setDeliveryAddress(
        JSON.parse(localStorage.getItem("address") || false)
      )
      if (this.$route.query.deal_id) {
        this.setDealId(this.$route.query.deal_id)
      }
      if (this.$route.query.cart) {
        this.getShareCart(this.$route.query.cart).then((data) => {
          const currentCart = JSON.parse(data.data.cart)
          this.getMakerBySlug({
            slug: currentCart.maker.slug,
            makerPage: false,
          }).then(() => {
            this.addToCart({
              ...currentCart,
              maker: this.chosenMaker,
            })
          })
        })
      } else {
        this.setCart(JSON.parse(localStorage.getItem("and-dine-cart") || false))
      }
    },
    logoutUser() {
      this.setShowAccount(false)
      this.customerLogout("/search")
    },
    handleResize() {
      this.setWindowSize(window.innerWidth)
    },
    goToMaker(val) {
      if (this.cartItemCount > 0 && val) {
        this.$route.name === "store-slug"
          ? window.scrollTo({ top: 600, behavior: "smooth" })
          : this.$router.push(`/store/${this.cart.maker.slug}`)
      }
    },
  },
}
